import { ApplicantDetailsReviewQuestions, FinanceDetailsReviewQuestions } from '../questions';

export const customFormattingFieldsList = [
  FinanceDetailsReviewQuestions.term.labelKey,
  FinanceDetailsReviewQuestions.numberOfApplicantsKey,
  FinanceDetailsReviewQuestions.dependentsKey,
  ApplicantDetailsReviewQuestions.income.employmentType,
  ApplicantDetailsReviewQuestions.income.timeTrading,
  ApplicantDetailsReviewQuestions.income.timeRemainingMonths,
  ApplicantDetailsReviewQuestions.income.timeRemainingYears,
  FinanceDetailsReviewQuestions.regionKey,
];

export const fieldsWithUnusulMultiplier = ['childBenefit', 'universalTaxCredits', 'stateDisabilityAllowance'];

export const isFalseValue = (value: any) => value === false || value === null || value === undefined;
